/**
 * A tarja de ligação.
 *
 * Só aparece quando há mesmo problema. Um cliente que pisca "a ligar…" em cada
 * reconexão de meio segundo treina as pessoas a ignorar o aviso — e depois o
 * aviso que interessa (estás offline, o que escreveste não saiu) passa
 * despercebido. Por isso: `ready` e `connecting` inicial não mostram nada.
 */

import { useStore } from "../store/store";

export function ConnectionBanner() {
  const status = useStore((s) => s.connectionStatus);
  const detail = useStore((s) => s.connectionDetail);
  const connect = useStore((s) => s.connect);

  if (status === "ready" || status === "idle" || status === "connecting") return null;

  if (status === "dead") {
    return (
      <div className="banner banner--dead" role="alert">
        <span>{detail ?? "A conexão caiu e não foi possível recuperar."}</span>
        <button type="button" className="button button--small" onClick={() => connect()}>
          Reconectar
        </button>
      </div>
    );
  }

  return (
    <div className={`banner banner--${status}`} role="status">
      <span className="banner__pulse" />
      {status === "resuming" ? "Retomando a sessão…" : "Sem conexão — tentando de novo…"}
      {detail ? <em>{detail}</em> : null}
    </div>
  );
}
